/* eslint-disable */

import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { Size } from "../../../logic/enums.ts";

const QuizQuestion = ({ answer, text }) => {
  return (
    <div>
      <div className="w-[500px] h-[300px] bg-gradient-to-br from-blue-800 to-blue-950 items-center justify-center text-center flex flex-col text-3xl p-6 font-bold">
        {text}
      </div>
      <div>{answer}</div>
    </div>
  );
};

const RaindropPlayground = () => {
  return (
    <div
      className={
        "flex flex-col h-full gap-4 overflow-y-scroll p-6 items-center justify-center"
      }
    >
      <RaindropButton
        isFluid={true}
        icon="fa-fire"
        size={Size.Large}
        style={ButtonStyle.Primary}
        title="Primary"
      />
      <RaindropButton
        isFluid={true}
        icon="fa-fire"
        size={Size.Large}
        style={ButtonStyle.Secondary}
        title="Secondary"
      />
      <RaindropButton
        isFluid={true}
        icon="fa-fire"
        size={Size.Large}
        style={ButtonStyle.Tertiary}
        title="Tertiary"
      />
      <RaindropButton
        isFluid={true}
        icon="fa-fire"
        size={Size.Large}
        style={ButtonStyle.Outline}
        title="Outline"
      />
      <RaindropButton
        isFluid={true}
        icon="fa-fire"
        size={Size.Large}
        style={ButtonStyle.Destructive}
        title="Destructive"
      />

      <RaindropButton
        isFluid={true}
        icon="fa-fire"
        size={Size.Large}
        style={ButtonStyle.Icon}
        title="Icon"
      />
    </div>
  );
};

export default RaindropPlayground;
